<div class="capacity-container">
  <div class="vertical-bar"></div>
  <!-- Top Row: Status, Temp, Network Speed -->
  <div class="top-row">
    <div class="capacity-item status-item">
      <span class="capacity-container-label">Status</span>
      <sn-appliance-status [status]="status"></sn-appliance-status>
    </div>

    <div class="capacity-item">
      <span class="capacity-container-label">Temp</span>
      <span class="capacity-container-value">{{ capacity?.currentTemperature | fsTemperature }}</span>
    </div>
    <fs-appliance-network-reload
      [networkSpeedUpdatedAtToolTip]="networkSpeedTimestampToolTip"
      [networkSpeedTimestamp]="capacity?.networkSpeedUpdatedAt"
      [networkSpeed]="networkSpeed"
      [isApplianceDown]="isApplianceDown"
      (reload)="onNetworkReload($event)"
    >
    </fs-appliance-network-reload>
  </div>

  <!-- Core Health Row -->
  <div class="health-row">
    <span class="health-label">Core Health</span>
    <sn-icon
      [matTooltip]="capacityStatusTimestampToolTip"
      [fontSet]="'far'"
      [fontIcon]="'fa-circle-info'"
      [size]="'sm'"
      [class]="'info-icon'"
    >
    </sn-icon>
    <fs-appliance-capacity-status
      *ngIf="updatesPending"
      [capacityStatus]="SnApplianceCapacityStatus.UpdatesPending"
    >
    </fs-appliance-capacity-status>
  </div>

  <!-- Storage Row -->
  <div class="capacity-indicators">
    <!-- Top line: label on the left -->
    <div class="capacity-indicator-label">
      <span>STORAGE</span>
    </div>

    <!-- Middle line: progress bar -->
    <fs-appliance-capacity-indicator [value]="storageUsagePercent">
    </fs-appliance-capacity-indicator>

    <!-- Bottom line: free-of-total info on the right -->
    <div class="indicator-info">{{ storageInfo }}</div>
  </div>

  <!-- Streaming Row -->
  <div class="capacity-indicators">
    <div class="capacity-indicator-label">
      <span class="bar-label">STREAMING</span>
    </div>

    <fs-appliance-capacity-indicator [value]="streamingUsagePercent">
    </fs-appliance-capacity-indicator>

    <div class="indicator-info">{{ streamingInfo }}</div>
  </div>
</div>
